import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AccessType } from "@quintype/components";
import { CustomLink } from "../custom-link";
import TimeAgo from "react-timeago";
import format from "date-fns/format";
import "./user-details.m.css";
import { SvgHandler } from "../svg-handler/svg-handler";
import { accessCheck } from "../../../isomorphic/utils";
import defaultAuthorIcon from "../../../assets/icons/default-author.svg";

function UserDetailsBase(props) {
  const email = get(props, ["member", "email"]);
  const phone = get(props, ["member", "metadata", "phone-number"], "");
  const accessTypeKey = get(props, ["config", "theme-attributes", "accesstypeKey"]);
  const disableMetering = get(props, ["config", "theme-attributes", "disableMetering"]) === "true";
  const isStaging = get(props, ["config", "theme-attributes", "accesstypeEnvironment"]) === "staging";
  const enableAccesstype = get(props, ["config", "theme-attributes", "enableAccesstype"], false);

  return (
    <AccessType
      enableAccesstype={accessCheck(enableAccesstype)}
      isStaging={isStaging}
      accessTypeKey={accessTypeKey} // "9rm1ijqQmGfJ2kwQ9zt2gWhK"
      email={email}
      phone={phone}
      disableMetering={disableMetering}
    >
      {({ getSubscriptionForUser }) => (
        <UserDetailsComponent getSubscriptionForUser={getSubscriptionForUser} {...props} />
      )}
    </AccessType>
  );
}

class UserDetailsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptions: [],
      loader: true,
      loadingSubscriptions: false
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.member && this.props.member) {
      this.setState({ loader: true });
    }
    if (this.state.loader && !this.state.loadingSubscriptions) {
      this.getUserSubscriptions();
    }
  }

  getUserSubscriptions = async () => {
    this.setState({ loadingSubscriptions: true });
    const { subscriptions } = await this.props.getSubscriptionForUser();
    this.setState({ subscriptions, loader: false });
  };

  renderImage() {
    const image = get(this.props, ["member", "avatar-url"]);
    if (image) {
      return <img src={image} />;
    }
    return (
      <span>
        <SvgHandler xlinkHref={defaultAuthorIcon} />
      </span>
    );
  }

  formatter(value, unit, suffix, date, defaultFormatter) {
    return format(new Date(date), "DD MMM, YYYY");
  }

  getActivePlan() {
    return this.state.subscriptions.find(plan => plan.active) || {};
  }

  renderSubscriptionDetails = () => {
    const { end_timestamp: endTimestamp, active: isActive } = this.getActivePlan();
    return isActive ? (
      <div styleName="subs-details" data-testid="subs-details">
        <span styleName="annual-subscription">Subscription</span>
        <span styleName="expire-time">
          expires on
          <span styleName="expire-time">
            <TimeAgo date={endTimestamp} formatter={this.formatter} title={null} />
          </span>
        </span>
      </div>
    ) : (
      <span styleName="subs-details"> No subscriptions yet</span>
    );
  };

  renderUserDetailsContent = () => {
    const email = get(this.props, ["member", "email"], "");
    const phone = get(this.props, ["member", "phone"]);
    const name = get(this.props, ["member", "name"], "");
    const isAccessible = get(this.props, ["config", "theme-attributes", "enableAccesstype"]);

    return (
      <Fragment>
        <div styleName="container-wrapper">
          <div styleName="author-image">{this.renderImage()}</div>
          <div styleName="author-details">
            <h2 styleName="author-name">{name}</h2>
            {accessCheck(isAccessible) && this.renderSubscriptionDetails()}
            <div styleName="email-detail">
              <span>EMAIL</span>
              <p>{email}</p>
            </div>
            {phone && (
              <div styleName="mob-detail">
                <span>PHONE</span>
                <p>{phone}</p>
              </div>
            )}
            {accessCheck(isAccessible) && (
              <div styleName="other-detail">
                <div data-testid="plan-btn" styleName="plan-btn">
                  <CustomLink href={"/subscription"}>Upgrade Plan</CustomLink>
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  loadingSkeleton = () => {
    const email = get(this.props, ["member", "email"], "");
    const phone = get(this.props, ["member", "phone"]);
    const isAccessible = get(this.props, ["config", "theme-attributes", "enableAccesstype"]);
    return (
      <div styleName="container-wrapper animation">
        <div styleName="load-style">
          <div styleName="load-img" />
        </div>
        <div>
          <div styleName="load-author-name" />
          <div styleName="load-subs-details" />
          <div styleName="load-line" />
          {email && (
            <div styleName="load-email-detail">
              <span styleName="load-email" />
              <p styleName="load-detail" />
            </div>
          )}
          {phone && (
            <div styleName="load-mob-detail">
              <span styleName="load-mobile" />
              <p styleName="load-detail" />
            </div>
          )}
          {accessCheck(isAccessible) && <div styleName="load-plan-btn" />}
        </div>
      </div>
    );
  };

  handleIfLoggedIn = () => {
    const member = get(this.props, ["member"]);
    if (this.state.loader) return this.loadingSkeleton();
    if (member) return this.renderUserDetailsContent();
    return (
      <div styleName="navigation-home-wrapper">
        <p>You have been successfully logged out</p>
        <div styleName={"navigate-home"}>
          <CustomLink href={"/"}>Go to Home Page</CustomLink>
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.handleIfLoggedIn()}</div>;
  }
}

UserDetailsComponent.propTypes = {
  getSubscriptionForUser: PropTypes.func,
  member: PropTypes.object,
  subscriptions: PropTypes.array
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"]),
  member: get(state, ["member"], null),
  subscriptions: get(state, ["subscriptions"], [])
});

const UserDetails = connect(mapStateToProps)(UserDetailsBase);

export { UserDetails };
